module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Sole to Soul")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgment"
    }
  }, [_vm._v("Acknowledgment")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#sound-tracks"
    }
  }, [_vm._v("Sound Tracks")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#chapter-1-turning-a-blind-eye"
    }
  }, [_vm._v("Chapter 1:  Turning a Blind Eye")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#chapter-2-the-family-box"
    }
  }, [_vm._v("Chapter 2:   The Family Box")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#chapter-3-gifts",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3:   Gifts")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter-4-the-world-is-going-to-hell",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4:   The World Is Going to Hell")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-5-red-light",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5:   Red Light")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#janet-nichols-dream-diary",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-6-odd-or-even",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6:   Odd or Even")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-7-first-date",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7:   First Date")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-8-on-a-wednesday",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8:   On a Wednesday")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-9-the-downpour",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9:   The Downpour")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-10-investigative-road-trip",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10:   Investigative Road Trip")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#current-day",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-11-the-misfits-road-trip-wheels-keep-spinnin",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11:   The Misfit’s Road Trip – Wheels Keep Spinnin’")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#section",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#section-1",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-12-my-name-is-jacob",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12:   My Name Is Jacob")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#chapter-13-rainbows-and-conspiracy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13:   Rainbows and Conspiracy")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#chapter-14-no-other-choice",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14:   No Other Choice")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#chapter-15-the-attack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15:   The Attack")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#chapter-16-two-hours",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16:   Two Hours")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#chapter-17-caved-in",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17:   Caved In")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#chapter-18-when-the-dust-settles",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18:   When the Dust Settles")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#chapter-19-strings-attached-the-sentinel-rises",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19:   Strings Attached, the Sentinel Rises")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-206d183d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0